module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--fr-4f276164789ef6c1536ddf30c752e774.webp";